export default __webpack_public_path__ + "4ae6280ce7007f9f937d1f4b147c6e37.webp";